module.exports = __webpack_public_path__ + "images/menu-task-sel.svg?f87c1d0f8e7d74ec8e3dc6a197ffcd50";